import package_json from '../../../package.json';
import {Component, OnInit, Optional} from '@angular/core';
import {AppContainerOptions, AppContainerService, BackdropContainerEnum, ISwUpdateOptions, SwUpdateService} from '@mydocma/app-container';
import {IMmConfig} from '@docma-mm-core/project/project.interface';
import {ConfigProvider} from '@mydocma/common';
import {CurrentFaultsSyncStateService} from '../../../projects/mydocma/mm/src/lib/mm-faults/current-faults-sync-state.service';
import {MatLegacyDialog as MatDialog} from "@angular/material/legacy-dialog";
import {TranslateService} from '@ngx-translate/core';
import {
  MmFaultsSyncDialogComponent
} from '../../../projects/mydocma/mm/src/lib/mm-faults/mm-faults-sync/mm-faults-sync-dialog/mm-faults-sync-dialog.component';
import {MydocmaPromptButtonTypeEnum, PromptDialogService} from '@mydocma/component-library/src/lib/prompt-dialog';
import {MydocmaPromptButton} from '@mydocma/component-library/src/lib/prompt-dialog/prompt-dialog.component';
import {FaultSyncService} from '@docma-mm-core/fault/sync/fault-sync.service';
import {firstValueFrom, Subject} from 'rxjs';
import {BackdropService} from '@mydocma/component-library/src/lib/backdrop';
import {UntilDestroy} from '@ngneat/until-destroy';
import {MmFaultsSyncService} from '../../../projects/mydocma/mm/src/lib/mm-faults/mm-faults-sync-service';
import {MmFaultsLoaderService} from '../../../projects/mydocma/mm/src/lib/mm-faults/mm-faults-loader.service';

@UntilDestroy()
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  // providers: [AppContainerOptions,
  //             AppContainerService]
})
export class MainComponent implements OnInit {

  public refreshFaultsSubject = new Subject<boolean>();

  protected readonly onclick = onclick;

  version: string = package_json.version;
  appcontainer: AppContainerOptions;

  constructor(
    @Optional() public options: AppContainerOptions,
    private appContainerService: AppContainerService,
    private configService: ConfigProvider<IMmConfig>,
    public readonly currentFaultsSyncStateService: CurrentFaultsSyncStateService,
    public dialog: MatDialog,
    private readonly translationService: TranslateService,
    private readonly dialogService: PromptDialogService,
    private readonly faultSyncService: FaultSyncService,
    private readonly updateService: SwUpdateService,
    private backDropService: BackdropService,
    private readonly faultsLoaderService: MmFaultsLoaderService) {

    options.appIcon.name = this.configService.getConfigData().appName;
    options.appIcon.color = this.configService.getConfigData().appIconColor;

    this.currentFaultsSyncStateService.faultsLoaderService = this.faultsLoaderService;

    // this.serviceWorkerUpdate();

    this.updateService.attachBeforeSwUpdateCallback(this.beforeUpdate.bind(this));
  }
  acOnRegister(appContainer: AppContainerOptions) {


    // buttons.push(new LinkSideNavButton({id: 'pix3', text: 'Help', url: '/pix/help'}));
    // appContainer.sideNavBar.buttons = buttons;
  }

  acOnUnregister(appContainer: AppContainerOptions) {
    appContainer.sideNavBar.buttons = [];
    appContainer.topActionsBar.buttons = [];
  }

  async ngOnInit() {
    this.appContainerService.notifyChanges((appcontainer) => {
      this.appcontainer = appcontainer;
      this.appcontainer.header.userMenuItems.version = this.version;
    });
  }

  private async serviceWorkerUpdate(){
    const registration = await navigator.serviceWorker.getRegistration();

    console.log('onInit: Service Worker...');
    console.log(registration);

    if (registration) {
      console.log('Service Worker update addEventListener...');

      registration.addEventListener('updatefound', async () => {
        const currentState = (await (await fetch('ngsw/state')).text()).match(/Driver state: (\w+)/)[1];
        console.error('Service Worker currentState');
        console.error(currentState);

        console.error('Service Worker update found!');
        // registration.update();
      });
    }
  }

  private async beforeUpdate(): Promise<ISwUpdateOptions> {

    console.log(`EXEC beforeUpdate`);

    let canUpdate = true;
    const backDrops = await firstValueFrom(this.backDropService.activeBackdrops$);
    if (backDrops) {
      canUpdate = backDrops.find(bd => bd.options?.name === BackdropContainerEnum.MydocmaAppHeader) ? false : true;
      console.log(`beforeUpdate: ${canUpdate}`);
    }

    return {
      allowUpdate: canUpdate,
      showUpdateDialog: canUpdate
    };
  }


  openFaultsSyncDialog() {
    const dialogRef = this.dialog.open(MmFaultsSyncDialogComponent, {
      panelClass: ['mydocma-dialog', 'mydocma-dialog-xs-fullscreen', 'mydocma-mm-mm-faults-sync-dialog'],
      autoFocus: false,
      disableClose: true });

    dialogRef.afterClosed().subscribe(async (result: {isSuccessful: boolean, ticketId: number}) => {
      if (result?.isSuccessful === true) {
        (await this.dialogService.showPromptDialog({
          title: this.translationService.instant('MM.syncFaults.dialog.finalSuccessMessageTitle'),
          content: this.translationService.instant('MM.syncFaults.dialog.finalSuccessMessage', {value: `<a href="https://edrsoftware.freshdesk.com/helpdesk/tickets/${result.ticketId}" target="_blank">https://edrsoftware.freshdesk.com/helpdesk/tickets/${result.ticketId}</a>`}),
          buttons: [
            ({
              text: await this.translationService.get('MM.general.button.ok').toPromise(),
              type: MydocmaPromptButtonTypeEnum.primary,
              value: true
            } as MydocmaPromptButton)
          ]
        }));

        // TODO: UPDATE CHANGE_STATE FOR GRID-FAULTS OBJECTS
        this.refreshFaultsSubject.next(true);
        this.faultSyncService.startSync();
      }
      else if (result?.isSuccessful === false) {

        (await this.dialogService.showPromptDialog({
          title: this.translationService.instant('MM.syncFaults.dialog.finalErrorMessageTitle'),
          content: this.translationService.instant('MM.syncFaults.dialog.finalErrorMessage'),
          buttons: [
            ({
              text: await this.translationService.get('MM.general.button.ok').toPromise(),
              type: MydocmaPromptButtonTypeEnum.primary,
              value: true
            } as MydocmaPromptButton)
          ]
        }));
      }
    });
  }
}
